'use client';

import Image from 'next/image';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ChatwootBtn } from './ChatwootBtn';

import styles from './ChatwootFallback.module.scss';

export const ChatwootFallback = () => {
  const initialized = useSelector((state) => state.chatwoot.initialized);
  const [hasChatwoot, setHasChatwoot] = useState(false);

  useEffect(() => {
    setHasChatwoot(Boolean(localStorage.getItem('chatwoot')));
  }, []);

  const ready = initialized || hasChatwoot;

  if (ready) return null;

  return (
    <button type="button" className={styles.btn}>
      <ChatwootBtn />
      <Image src="/img/misc/chat-placeholder.svg" alt="" width={157} height={48} />
    </button>
  );
};
